import { apiSlice } from './apiSlice';

export const partnerCodesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    validatePartnerCode: builder.mutation({
      query: (body) => ({
        url: '/api/partner-codes/validate',
        method: 'POST',
        body,
      }),
    }),
    redeemPartnerCode: builder.mutation({
      query: (body) => ({
        url: '/api/partner-codes/redeem',
        method: 'POST',
        body,
      }),
    }),
    adminListPartnerCodes: builder.query({
      query: (params = {}) => ({
        url: '/api/admin/partner-codes',
        params,
      }),
      providesTags: ['PartnerCodes'],
      keepUnusedDataFor: 5,
    }),
    adminCreatePartnerCode: builder.mutation({
      query: (body) => ({
        url: '/api/admin/partner-codes',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PartnerCodes'],
    }),
    adminUpdatePartnerCode: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/api/admin/partner-codes/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['PartnerCodes'],
    }),
    adminListPartnerRedemptions: builder.query({
      query: (params = {}) => ({
        url: '/api/admin/partner-redemptions',
        params,
      }),
      providesTags: ['PartnerRedemptions'],
      keepUnusedDataFor: 5,
    }),
    adminListPricingTiers: builder.query({
      query: () => ({
        url: '/api/admin/pricing-tiers',
      }),
      providesTags: ['PricingTiers'],
      keepUnusedDataFor: 5,
    }),
    adminCreatePricingTier: builder.mutation({
      query: (body) => ({
        url: '/api/admin/pricing-tiers',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PricingTiers'],
    }),
    adminApplyTierPricesByCategory: builder.mutation({
      query: (body) => ({
        url: '/api/admin/product-tier-prices/category',
        method: 'POST',
        body,
      }),
    }),
    adminLookupTierPricesForProducts: builder.mutation({
      query: (body) => ({
        url: '/api/admin/product-tier-prices/lookup',
        method: 'POST',
        body,
      }),
    }),
    adminGetProductTierPrices: builder.query({
      query: (productId) => ({
        url: `/api/admin/product-tier-prices/product/${productId}`,
      }),
      providesTags: (_result, _error, productId) => [{ type: 'ProductTierPrices', id: productId }],
      keepUnusedDataFor: 5,
    }),
    adminUpsertProductTierPrices: builder.mutation({
      query: ({ productId, prices }) => ({
        url: `/api/admin/product-tier-prices/product/${productId}`,
        method: 'PUT',
        body: { prices },
      }),
      invalidatesTags: (_result, _error, { productId }) => [
        { type: 'ProductTierPrices', id: productId },
      ],
    }),
    adminAssignUserTier: builder.mutation({
      query: ({ userId, tierId }) => ({
        url: `/api/admin/users/${userId}/tier`,
        method: 'PATCH',
        body: { tierId },
      }),
    }),
    adminRemoveUserTier: builder.mutation({
      query: ({ userId }) => ({
        url: `/api/admin/users/${userId}/tier`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useValidatePartnerCodeMutation,
  useRedeemPartnerCodeMutation,
  useAdminListPartnerCodesQuery,
  useAdminCreatePartnerCodeMutation,
  useAdminUpdatePartnerCodeMutation,
  useAdminListPartnerRedemptionsQuery,
  useAdminListPricingTiersQuery,
  useAdminCreatePricingTierMutation,
  useAdminApplyTierPricesByCategoryMutation,
  useAdminLookupTierPricesForProductsMutation,
  useAdminGetProductTierPricesQuery,
  useAdminUpsertProductTierPricesMutation,
  useAdminAssignUserTierMutation,
  useAdminRemoveUserTierMutation,
} = partnerCodesApiSlice;
